import { inject, signal } from '@angular/core';
import { User } from '@web-portal/domains/shared/domain-models';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { filter } from 'rxjs';
import { UserEventBus } from '@web-portal/domains/shared/event-bus';

const initialState: User | null = null;

/**
 * @internal
 * @description
 * User store.
 */
export class UserStore {
  private readonly _user = signal(initialState);
  public readonly user = this._user.asReadonly();

  private readonly userEventBus = inject(UserEventBus);

  constructor() {
    this.userEventBus
      .on$<User>('[User] initialized')
      .pipe(
        filter(event => {
          return this.isUser(event);
        }),
        takeUntilDestroyed()
      )
      .subscribe(event => {
        this.setUser(event);
      });
  }

  private setUser(user: User | null) {
    this._user.set(user);
  }

  private isUser(user: unknown): user is User {
    return (
      typeof user === 'object' &&
      user !== null &&
      'email' in user &&
      'firstName' in user &&
      'lastName' in user
    );
  }
}
